import ActionType from '../actionTypes/buyDialogActionTypes';
import { CartItems } from '../../schemas/cartItems';

export interface BuyDialogState {
    loadCartItems: CommonState & {
        data: CartItems | null;
    };
    deleteCartItem: CommonState;
}

interface CommonState {
    failed: boolean;
    loading: boolean;
    success: boolean;
    finished: boolean;
}

interface loadCartItemsAction {
    type: string;
    data: CartItems;
}

const commonState = {
    failed: false,
    loading: false,
    success: false,
    finished: false,
};

const stateLoadCartItems = 'loadCartItems';
const stateDeleteCartItem = 'deleteCartItem';
type SubState = typeof stateLoadCartItems | typeof stateDeleteCartItem;

const getInitialState = (): BuyDialogState => ({
    [stateLoadCartItems]: {
        ...commonState,
        data: null,
    },
    [stateDeleteCartItem]: {
        ...commonState,
    },
});

const reset = (): BuyDialogState => getInitialState();

const start = (
    subStateName: SubState,
    state: BuyDialogState
): BuyDialogState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: true,
        success: false,
        finished: false,
    },
});

const success = (
    subStateName: SubState,
    state: BuyDialogState,
    action: loadCartItemsAction
): BuyDialogState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: false,
        loading: false,
        success: true,
        finished: true,
    },
});

const successWithData = (
    subStateName: SubState,
    state: BuyDialogState,
    action: loadCartItemsAction
): BuyDialogState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        data: action.data,
        failed: false,
        loading: false,
        success: true,
        finished: true,
    },
});

const fail = (
    subStateName: SubState,
    state: BuyDialogState
): BuyDialogState => ({
    ...state,
    [subStateName]: {
        ...state[subStateName],
        failed: true,
        loading: false,
        success: false,
        finished: true,
    },
});

const reducer = (state = getInitialState(), action: any): BuyDialogState => {
    switch (action.type) {
        case ActionType.loadCart.start:
            return start(stateLoadCartItems, state);
        case ActionType.loadCart.success:
            return successWithData(stateLoadCartItems, state, action);
        case ActionType.loadCart.fail:
            return fail(stateLoadCartItems, state);
        case ActionType.loadCart.reset:
            return reset();

        case ActionType.deleteCartItem.start:
            return start(stateDeleteCartItem, state);
        case ActionType.deleteCartItem.success:
            return success(stateDeleteCartItem, state, action);
        case ActionType.deleteCartItem.fail:
            return fail(stateDeleteCartItem, state);
        case ActionType.deleteCartItem.reset:
            return reset();

        default:
            return state;
    }
};

export default reducer;
